import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { AgGridModule } from "@bfx/ag-grid-angular";
import { AutoCompleteModule } from "@bfx/primeng/autocomplete";
import { DataTableModule } from "@bfx/primeng/datatable";
import { InputTextModule } from "@bfx/primeng/inputtext";
import { PERFECT_SCROLLBAR_CONFIG } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { TranslateModule } from "@ngx-translate/core";

import { BfxOrderTransferComponent } from "./bfx-order-transfer.component";
import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { BfxElementsLibraryModule } from "app/bfx-element-library/bfx-elements-library.module";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { BaseComponentsModule } from "shared/base-components/base-components.module";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  imports: [
    CommonModule,
    DataTableModule,
    BfxSharedModule,
    TranslateModule,
    FormsModule,
    InputTextModule,
    AutoCompleteModule,
    BfxElementsLibraryModule,
    NativeDesktopModule,
    AgGridModule.withComponents([]),
    PerfectScrollbarModule,
    BaseComponentsModule,
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
  declarations: [BfxOrderTransferComponent],
  exports: [BfxOrderTransferComponent],
  bootstrap: [BfxOrderTransferComponent],
})
export class BfxOrderTransferModule {}
